import React, { useEffect, useState } from 'react';
import { Route, Switch } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import axios from 'axios';
import { NavBar, Header, Loading, HomeContentIn, HomeContent } from './components';
import { Profile, ListView } from './views';
import ProtectedRoute from './auth/protected-route';
import './app.css';
import {address} from './common-util'


export const functionContext = React.createContext();

const App = () => {

var today = new Date();
var dd = String(today.getDate()).padStart(2, '0');
var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
var yyyy = today.getFullYear();

today = mm + '/' + dd + '/' + yyyy;
// console.log(today);

function handleYearChange(e) {
  setcurrentYear(e)
  // console.log(e)
}

  const nowYear = +today.substr(6, 4);
  const nowMonth = +parseInt(today.substr(0, 2), 10);
  const currentDay = +today.substr(3, 2);
  const [currentYear, setcurrentYear] = useState(+today.substr(6, 4));
  const [currentMonth, setcurrentMonth] = useState(+parseInt(today.substr(0, 2), 10));

  const [nameToDisplay, setnameToDisplay] = useState("Enter event...");
  const [dateToDisplay, setdateToDisplay] = useState("");
  const [ageToDisplay, setageToDisplay] = useState("");
  const [zodiacToDisplay, setzodiacToDisplay] = useState("");

  const [nameToEdit, setnameToEdit] = useState('Edit user');
  const [dateToEdit, setdateToEdit] = useState('');
  const [idToEdit, setidToEdit] = useState();

  const [isEditing, setisEditing] = useState(false)

  const functionContextValue = {
    setnameToDisplay:setnameToDisplay,
    setdateToDisplay:setdateToDisplay,
    setageToDisplay:setageToDisplay,
    setzodiacToDisplay:setzodiacToDisplay,
  }

  //Get the legged in user information.
  const { 
    isAuthenticated,
    getAccessTokenSilently,
  } = useAuth0();

  //Wait for the authentication to load.
  const { isLoading } = useAuth0();

  const [userevents, setuserevents] = useState([]);

  // console.log(currentDay)

//Get events for a selected month and a specific user(this is for timeline view)
const [monthUserEvents, setmonthUserEvents] = useState([]);

const [selectedMonth, setselectedMonth] = useState(1);

useEffect(() => {
  setcurrentYear(+today.substr(6, 4))
  }, []);

  // console.log("HERE: ", currentYear, selectedMonth)

async function getmonthUserEvents(selectedMonth, currentYear) {

  // console.log('currentYear inside async function', currentYear)
  // console.log('selectedMonth inside async function', selectedMonth)
  // await console.log(year);
  
  if (selectedMonth === undefined || selectedMonth === "undefined") {
    selectedMonth = 1
  }

  if (currentYear === undefined || currentYear === "undefined") {
    currentYear = 2022
  }

  try {
    const token = await getAccessTokenSilently();
    const res = await axios.get(`${address}monthEvents?month=${selectedMonth}&year=${currentYear}`, {
    headers: {
      authorization: `Bearer ${token}`
    }
  })
  const monthUserEvents = res.data; //using axios and it parses the body
  // console.log(res);
  setmonthUserEvents(Object.values(monthUserEvents));
  // console.log(monthUserEvents)
  } catch (error) {
    console.log(error.message)
  }
}

useEffect(() => {
  getmonthUserEvents();
  }, [isAuthenticated]);

  useEffect(() => {
    setselectedMonth(selectedMonth, getmonthUserEvents(selectedMonth, currentYear))
    }, [currentYear]);

  function changeSelectedMonth(x) {
    setselectedMonth(+x, getmonthUserEvents(x, currentYear))
    setcurrentMonth(+x)
  }

  //Add event for user




//Add a event
  async function addevent(newUserName, newUserevent) {
 
      try {
        const token = await getAccessTokenSilently();
        const res = await fetch(`${address}addevent?name=${newUserName}&date=${newUserevent}`,
        {
            method: "POST",
            headers: { 
              authorization: `Bearer ${token}`,
            }
            // body: JSON.stringify(body)
        });
  
        console.log(res);
    } catch (err) {
        console.error(err.message);
    }
    
  }

  //Update a event
async function updateevent(idToEdit, nameToEdit, dateToEdit) {

    try {
      const token = await getAccessTokenSilently();
      const res = await fetch(`${address}updateevent?bid=${idToEdit}&newbname=${nameToEdit}&newbdate=${dateToEdit}`,
      {
          method: "PUT",
          headers: { 
            authorization: `Bearer ${token}`,
          }
          // body: JSON.stringify(body)
      });

      console.log(res);
  } catch (err) {
      console.error(err.message);
  }
  }

  //Delete a event
  async function deleteevent(idToEdit) {

    try {
      const token = await getAccessTokenSilently();
      const res = await fetch(`${address}deleteevent?bid=${idToEdit}`,
      {
          method: "DELETE",
          headers: { 
            authorization: `Bearer ${token}`,
          }
          // body: JSON.stringify(body)
      });

      console.log(res);
  } catch (err) {
      console.error(err.message);
  }
  }

  const { user } = useAuth0();
  // const { nickname, name, picture, email } = user;
//  console.log(user)

  if (isLoading) {
    return <Loading />;
  } 


 
  // console.log("CURRENT INSIDE APP", currentMonth, currentYear)

//Notes on the return 
// We have a terniary on the "/" path so we can mostly use the same structure while he is logged out than logged in. 
  return (
    <functionContext.Provider value={functionContextValue}>
    <div id="app-container">

    <NavBar setcurrentYear={setcurrentYear} currentYear={currentYear} currentMonth={currentMonth} updateevent={updateevent} deleteevent={deleteevent} changeSelectedMonth={changeSelectedMonth} setnameToEdit={setnameToEdit} setdateToEdit={setdateToEdit} setidToEdit={setidToEdit} setisEditing={setisEditing} addevent={addevent} isEditing={isEditing} nameToDisplay={nameToDisplay} dateToDisplay={dateToDisplay} nameToEdit={nameToEdit} dateToEdit={dateToEdit} idToEdit={idToEdit} />

     
        <Switch>
          
          <Route path="/" exact render={(props) => (isAuthenticated) ?
          <HomeContentIn {...props} nowMonth={nowMonth} nowYear={nowYear} selectedMonth={selectedMonth} currentDay={currentDay} currentYear={currentYear} currentMonth={currentMonth} setnameToEdit={setnameToEdit} setdateToEdit={setdateToEdit} setidToEdit={setidToEdit} setisEditing={setisEditing} isEditing={isEditing} monthUserEvents={monthUserEvents} nameToDisplay={nameToDisplay} dateToDisplay={dateToDisplay} ageToDisplay={ageToDisplay} zodiacToDisplay={zodiacToDisplay} /> 
          : 
          <HomeContent {...props}  currentYear={currentYear} currentMonth={currentMonth} />} />
          
          
          <ProtectedRoute path="/Profile" component={Profile} />
          <Route path="/ListView" exact render={(props) => <ListView {...props} currentYear={currentYear} />}/>
        </Switch>
      
    <Header handleYearChange={handleYearChange} currentYear={currentYear} currentMonth={currentMonth} changeSelectedMonth={changeSelectedMonth} selectedMonth={selectedMonth} monthUserEvents={monthUserEvents}/>
      
    </div>
    </functionContext.Provider>
  );
};

export default App;